<!-- Spinner while statuses are being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading the status list. Click below try again.
    <button hc-button size="lg" (click)="loadStatuses()">Reload Statuses</button>
</div>

<div class="admin-statuses-table-container" [hidden]="loadError || loading">
    <h2> <hc-icon fontSet="fa" fontIcon="fa-check-circle"></hc-icon> Statuses </h2>
    <div class="admin-statuses-table-action-bar">
        <button hc-button (click)="openAddEditModal(addEditStatusModal, false)">Add Status</button>
            <hc-search-bar
                #searchbar
                placeholder="Search statuses"
                (triggerSearch)="applyFilter($event)"
                class="admin-statuses-search"
            ></hc-search-bar>
    </div>
    <table hc-table [borders]="false" class="admin-statuses-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="id">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="idHeader">ID</th>
            <td hc-index-cell *hcCellDef="let element">{{ element.statusID }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Description Column -->
        <ng-container hcColumnDef="description">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Description</th>
            <td hc-cell *hcCellDef="let element" [innerHTML]="element.description"></td>
        </ng-container>

        <!-- Icon Actions Column -->
        <ng-container hcColumnDef="actions" justify="center">
            <th hc-header-cell *hcHeaderCellDef id="actionsHeader"></th>
            <td hc-cell *hcCellDef="let element">
                <div class="hc-table-actions">
                    <span
                        hcMenuIcon
                        class="fa fa-trash hc-action-ico"
                        hcTooltip="Remove status"
                        (click)="removeStatus(element)"
                    ></span>
                    <span
                        hcMenuIcon
                        class="fa fa-pencil hc-action-ico"
                        hcTooltip="Edit status"
                        (click)="openAddEditModal(addEditStatusModal, true, element)"
                    ></span>
                </div>
            </td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminStatusesDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminStatusesDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No statuses meet your search criteria.</span>
    </div>

    <hc-pagination
        [length]="adminStatusesListLength"
        [pageSize]="adminStatusesPageSize"
        [hidden]="loadError || loading"
    ></hc-pagination>
</div>

<ng-template #addEditStatusModal let-dismiss="dismiss" let-data="data">
    <hc-modal>
        <hc-modal-header>{{ data.edit ? 'Edit' : 'Add' }} Status</hc-modal-header>
        <hc-modal-body>
            <form [formGroup]="adminStatusForm" class="admin-status-form">
                <hc-form-field>
                    <hc-label>Name:</hc-label>
                    <input hcInput formControlName="name" placeholder="Enter name" class="name-input" [required]="true" />
                    <hc-error>A name is required</hc-error>
                </hc-form-field>
                <label class="hc-form-field-label">
                    <hc-label>Description:</hc-label>
                    <span class="hc-required-marker"> *</span>
                </label>
                <quill-editor class="content-editor" formControlName="description" [required]="true"
                        placeholder="Enter description" [modules]="quillConfig"
                        [styles]="quillStyles"></quill-editor>
            </form>
        </hc-modal-body>
        <hc-modal-footer>
            <button hc-button buttonStyle="link" (click)="dismiss()">Cancel</button>
            <button
                hc-button
                buttonStyle="primary"
                [disabled]="data.edit ? !adminStatusForm.dirty : !adminStatusForm.valid"
                (click)="data.edit ? editStatus() : addStatus()"
            >
                {{ data.edit ? 'Update' : 'Add' }}
            </button>
        </hc-modal-footer>
    </hc-modal>
</ng-template>
